import { PatternSettings } from "./PatternSettings";

export const defaultPatternSettings: PatternSettings = {
  siteswap: "51",
  beatDuration: 0.24,
  dwellPath: "(30)(10)",
  dwellRatio: 0.8,
};
